import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';

import { ModalContainer } from "./shared/components/modal-container/modal-container";
import { Language } from './core/services/language';
import { Popup } from "./shared/ui/popup/popup";

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ModalContainer, Popup],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App implements OnInit {

  constructor(private languageService: Language, private router: Router) { }

  ngOnInit(): void {
    const savedLang = localStorage.getItem('app-lang') as 'en' | 'ar';
    if (savedLang) {
      this.languageService.setLanguage(savedLang);
    }

    // scroll to top on route change
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      });
  }

}
